import { api } from "@/api/axios.ts";
import { ApiFile } from "@/types/common.types";
import { ApiFileLink } from "@/types/file.types";
import { AxiosProgressEvent } from "axios";

export const apiFiles = {
  add: (data: FormData, onUploadProgress?: (event: AxiosProgressEvent) => void) => {
    return api.post<ApiFile>(`/api/v1/files/add`, data, undefined, { onUploadProgress });
  },
  delete: (uuid: string) => {
    return api.delete(`/api/v1/files/delete/${uuid}`);
  },
  getLink: (uuid: string, days: number) => {
    return api.get<ApiFileLink>(`/api/v1/files/links?uuid=${uuid}&days=${days}`);
  },
  getPrivate: (uuid: string) => {
    return api.get<BlobPart>(`/api/v1/files/private/${uuid}`, undefined, undefined, {
      responseType: "blob",
    });
  },
};
